export const TOKEN_OBTAIN = "account/login/";
export const TOKEN_REFRESH = "account/refresh/";
export const REGISTER_USER = "account/register/";
export const CURRENT_TIME = "account/time/";

export const CHAT_BOTS = "chat/bots/";
export const CHAT_SESSIONS = "chat/sessions/";
export const CHAT_TALK = "chat/talk/";

export const GRADE_SUBMIT = "grade/submit/";
